import type { FC } from '../../lib/teact/teact';
import React, { memo, useEffect, useRef, useState } from '../../lib/teact/teact';
import { getActions } from '../../global';

import { LeftColumnContent } from '../../types';

import buildClassName from '../../util/buildClassName';

import styles from './MobileNavBar.module.scss';

type OwnProps = {
  activeTab?: 'contacts' | 'calls' | 'chats' | 'settings' | 'wallet' | 'trade' | 'gaito' | 'bookings' | 'reviews' | 'admin';
  onTabClick?: (tab: string) => void;
};

const BASE_TABS = [
  { id: 'contacts', icon: 'icon-group', label: 'Contacts' },
  { id: 'calls', icon: 'icon-phone', label: 'Appels' },
  { id: 'chats', icon: 'icon-message', label: 'Échanges' },
  { id: 'settings', icon: 'icon-settings', label: 'Paramètres' },
  // Hidden tabs
  // { id: 'wallet', icon: 'icon-card', label: 'Ví' },
  // { id: 'trade', icon: 'icon-trade', label: 'Trade' },
  // { id: 'gaito', icon: 'icon-heart', label: 'Gaito' },
  // { id: 'bookings', icon: 'icon-calendar', label: 'Lịch hẹn' },
  // { id: 'reviews', icon: 'icon-favorite', label: 'Đánh giá' },
];

const ADMIN_TAB = { id: 'admin', icon: 'icon-admin', label: 'Admin' };

const MobileNavBar: FC<OwnProps> = ({
  activeTab = 'chats',
  onTabClick,
}) => {
  if (activeTab === 'admin') {
    return null;
  }

  const containerRef = useRef<HTMLDivElement>();
  const { openLeftColumnContent, openSettingsScreen } = getActions();
  const [isAdmin, setIsAdmin] = useState(() => {
    try {
      const token = localStorage.getItem('telegram_token');
      if (!token) return false;
      const b64 = token.split('.')[1];
      if (!b64) return false;
      const payload = JSON.parse(atob(b64.replace(/-/g, '+').replace(/_/g, '/')));
      return Boolean(payload.is_admin);
    } catch { return false; }
  });
  const [TABS, setTABS] = useState(() => {
    try {
      const token = localStorage.getItem('telegram_token');
      if (!token) return BASE_TABS;
      const b64 = token.split('.')[1];
      if (!b64) return BASE_TABS;
      const payload = JSON.parse(atob(b64.replace(/-/g, '+').replace(/_/g, '/')));
      return payload.is_admin ? [...BASE_TABS, ADMIN_TAB] : BASE_TABS;
    } catch { return BASE_TABS; }
  });

  // Re-check when token changes (login/logout)
  useEffect(() => {
    const token = localStorage.getItem('telegram_token');
    if (!token) { setIsAdmin(false); setTABS(BASE_TABS); return; }
    try {
      const b64 = token.split('.')[1];
      const payload = JSON.parse(atob(b64.replace(/-/g, '+').replace(/_/g, '/')));
      const admin = Boolean(payload.is_admin);
      setIsAdmin(admin);
      setTABS(admin ? [...BASE_TABS, ADMIN_TAB] : BASE_TABS);
    } catch { /* ignore */ }
  }, []);

  const handleTabClick = (tab: string) => {
    // Navigation logic
    switch (tab) {
      case 'contacts':
        openLeftColumnContent({ contentKey: LeftColumnContent.Contacts });
        break;
      case 'calls':
        // Open chat list and filter for calls (or implement calls screen later)
        openLeftColumnContent({ contentKey: LeftColumnContent.ChatList });
        break;
      case 'chats':
        openLeftColumnContent({ contentKey: LeftColumnContent.ChatList });
        break;
      case 'settings':
        openLeftColumnContent({ contentKey: LeftColumnContent.Settings });
        break;
      case 'wallet':
        openLeftColumnContent({ contentKey: LeftColumnContent.Wallet });
        break;
      case 'trade':
        openLeftColumnContent({ contentKey: LeftColumnContent.Trade });
        break;
      case 'gaito':
        openLeftColumnContent({ contentKey: LeftColumnContent.Gaito });
        break;
      case 'bookings':
        openLeftColumnContent({ contentKey: LeftColumnContent.Bookings });
        break;
      case 'reviews':
        openLeftColumnContent({ contentKey: LeftColumnContent.Reviews });
        break;
      case 'admin':
        openLeftColumnContent({ contentKey: LeftColumnContent.Admin });
        break;
      default:
        break;
    }

    if (onTabClick) {
      onTabClick(tab);
    }
  };

 return (
    <div className={styles.root}>
      <div className={styles.container} ref={containerRef}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              className={buildClassName(
                styles.tab,
                isActive && styles.active,
              )}
              onClick={() => handleTabClick(tab.id)}
            >
              <i className={buildClassName('icon', tab.icon, styles.icon)} />
              <span className={styles.label}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default memo(MobileNavBar);
